import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import fetchWP from './utils/fetchWP';
import Loader from './utils/loader'

export default class Listing extends Component {

    render() {
     
        return (
            <div class="awdp_listing">
                <div>
                    <Rows />
                </div>
            </div>
        );
    }
}

class Rows extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            items: []
        }
        this.fetchWP = new fetchWP({
            restURL: window.awdp_object.root,
            restNonce: window.awdp_object.api_nonce,
        });
    }
    componentDidMount() {
       document.body.classList.remove('wdpa-details'); 
       this.getRules();
    }
    getRules = () => {
        this.fetchWP.get('rules')
            .then( 
                (json) => this.setState({
                    loading: false,
                    items: json,
                }),
                (err) => console.log('error', err)
            );
    };
    render() {

        var out = '';
        if(this.state.items != null){
            out = this.state.items.map((item, i) => (
                <Row key={i} item={item} />
            ));
        }

        if(this.state.loading) 
            return (<Loader />);
        else 
            return (<table class="wp-list-table widefat fixed striped"><thead><tr><th scope="col" id="title" class="manage-column awdp-column column-primary large"><span>Title</span></th><th scope="col" class="manage-column awdp-column xlarge"><span>Discount Type</span></th><th scope="col" class="manage-column awdp-column xsmall"><span>Value</span></th><th scope="col" class="manage-column awdp-column xsmall"><span>Priority</span></th><th scope="col" class="manage-column awdp-column small"><span>Start Date</span></th><th scope="col" class="manage-column awdp-column small"><span>End Date</span></th><th scope="col" class="manage-column awdp-column xsmall awdp_center_text"><span>Status</span></th></tr></thead><tbody>{out}</tbody></table>);
    }

}

function Row(props) {
    {console.log(props.item)}
    return ( 
        <tr><td><Link title="Edit" to={'/rule/' + props.item.discount_id}>{props.item.discount_title != '' ? props.item.discount_title : 'Pricing Rule' }</Link></td><td>{props.item.discount_type != '' ? props.item.discount_type_name : '-'}</td><td>{props.item.discount_value != '' ? props.item.discount_value : '-'}</td><td>{props.item.discount_priority != '' ? props.item.discount_priority : '-'}</td><td>{props.item.discount_start_date != '' ? props.item.discount_start_date : '-'}</td><td>{props.item.discount_end_date != '' ? props.item.discount_end_date : '-'}</td><td class="awdp_center_text">{props.item.discount_status == 1 ? <span>ACTIVE</span> : <span class='awdp_inactive'>INACTIVE</span>}</td></tr>
    );
}